import { z } from 'zod';
export const taxFormType = z.enum(['W-9', 'W-8BEN', 'W-8BEN-E']);
